import { Component, signal } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { Observable, takeUntil } from 'rxjs';
import { Note } from 'src/app/calvin-emr-shared/models/note.model';
import { OrderSet } from 'src/app/calvin-emr-shared/models/order-set.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { ProviderOrder } from 'src/app/calvin-emr-shared/models/provider-order.model';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';

@Component({
  selector: 'app-order-set-view-dialog',
  imports: [
    ButtonDirective,
    TableModule,
  ],
  templateUrl: './order-set-view-dialog.component.html',
  styleUrl: './order-set-view-dialog.component.scss',
  standalone: true,
})
export class OrderSetViewDialogComponent {
  orderSet: OrderSet;
  nursingOrders = signal<Note[]>([]);
  providerOrders = signal<ProviderOrder[]>([]);

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private patientStore: PatientDashboardStore,
  ) {
    const patient$ = this.patientStore.patient$.pipe(takeUntil(patientStore.destroy$));
    this.orderSet = config.data as OrderSet;
    patient$.subscribe((patient: Patient) => {
      this.nursingOrders.set(patient.nursingOrders.filter((no: Note) =>
        this.orderSet.nursingOrderIds.includes(no.id)));
      this.providerOrders.set(patient.providerOrders.filter((po: ProviderOrder) =>
        this.orderSet.providerOrderIds.includes(po.id)));
    });
  }

  closeDialog() {
    this.ref.close();
  }
}
